/**
 * `hashKnowledgeBaseContent` for the browser, where node:crypto is absent: the SHA-256 of the trimmed content. Null
 * outside a secure context, where Web Crypto is unavailable — the save then goes unchecked.
 */
export async function hashKnowledgeBaseContentInBrowser(content: string): Promise<string | null> {
  const subtle = globalThis.crypto?.subtle
  if (!subtle) return null
  const digest = await subtle.digest('SHA-256', new TextEncoder().encode(content.trim()))
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('')
}
